'use client'

import { useEffect } from 'react'
import { useUser } from '@/providers/UserContext'
import { portalApiClient } from '@/platform/http'
import * as PayloadAPI from '@/services/payload/payloadRepository'
import * as AuthAPI from '@/services/shared/authRepository'
import * as OrdersAPI from '@/services/client/ordersRepository'
import * as PartnersAPI from '@/services/shared/partnersRepository'
import * as KitsAPI from '@/services/patient/kits'
import * as UserAPI from '@/services/patient/user'
import * as PartnerAPI from '@/services/patient/partner'
import * as ClientUsersAPI from '@/services/client/clientUsersRepository'

declare global {
  interface Window {
    AshAPI?: {
      api: typeof portalApiClient
      payload: typeof PayloadAPI
      auth: typeof AuthAPI
      orders: typeof OrdersAPI
      partners: typeof PartnersAPI
      clientUsers: typeof ClientUsersAPI
      kits: typeof KitsAPI
      user: typeof UserAPI
      partner: typeof PartnerAPI
    }
  }
}

export function AshAPIInit() {
  const { user } = useUser()

  useEffect(() => {
    if (typeof window === 'undefined') return
    const email = user?.email_address || ''
    const isAsh = /@poweredbyash\.com$/i.test(email)
    if (!isAsh) return

    window.AshAPI = {
      api: portalApiClient,
      payload: PayloadAPI,
      auth: AuthAPI,
      orders: OrdersAPI,
      partners: PartnersAPI,
      clientUsers: ClientUsersAPI,
      user: UserAPI,
      kits: KitsAPI,
      partner: PartnerAPI,
    }
  }, [user])

  return null
}

export default AshAPIInit
